import { hexToRgb } from '../../../../../platform/src/helpers/hexToRgb';

function createCssVariables(block, object) {
    Object.keys(object).forEach((key) => {
        const lowercaseKey = key.toLowerCase();
        if (lowercaseKey.includes('color') && object[key]?.length) {
            block.style.setProperty(`--app-${key}`, `${hexToRgb(object[key])}`);
        }

        if (lowercaseKey.includes('percent')) {
            block.style.setProperty(`--app-${key}`, `${object[key]}%`);
        }

        if (lowercaseKey.includes('size')) {
            block.style.setProperty(`--app-${key}`, object[key]);
        }

        if (lowercaseKey.includes('font') && !!object[key]) {
            block.style.setProperty(`--app-${key}`, `"${object[key]}"`);
        }

        if (typeof object[key] === 'boolean') {
            block.style.setProperty(`--app-${key}`, +object[key]);
        }
    })
}

export default createCssVariables;
